import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import logo from '../../assets/img/logosmalltrans.png' 
import ReactTimeout from 'react-timeout'


class Header extends Component {
  constructor() {
    super()
    this.state = {
      menuIsActive: false    }
  }

  toggleMenu = () => {
    const currentMenuState = this.state.menuIsActive
    this.setState({menuIsActive: !currentMenuState})
  }

  render = () => {
    return (
      <nav>
        <div id="header" className="flex flex-direction-rows items-stretch bg-dark-gray pa2">
          <div id="logo" className="flex items-center mw3 pr3 pt2 h-auto">
            {/* the div below is necessary for firefox */}
            <div><img src={logo} alt=""/></div>
          </div>
          <Link id="kes" to="/" className="link flex items-center pathway f2 f1-ns near-white hover-gray">
            KEEP EUREKA STRONG
          </Link>
          <div className="flex pointer items-center pathway near-white f3 pr2 float-me-right link animate hover-gray"
              onClick={this.toggleMenu}>
            <span className="dn dib-ns">MENU</span> 
            <i className={`fa fa-caret-down pl2 ${this.state.menuIsActive ? "dn" : "dib"}`} aria-hidden="true"></i>
            <i className={`fa fa-times pl2 ${this.state.menuIsActive ? "dib pb1" : "dn"}`} aria-hidden="true"></i>
          </div>
        </div>
        { this.state.menuIsActive &&
          <div className={`menu flex flex-column flex-row-l justify-around items-center pathway ${this.state.menuIsActive ? "dib" : "dn"}`}>
            <Link to="/directory" onClick={() => this.toggleMenu()} className="f2rem b--dark-gray bb bt br-l bl-l bg-gray no-underline hover-bg-silver bg-animate pa2 w-100 tc near-white">Local Directory</Link>
            <Link to="/calendar" onClick={() => this.toggleMenu()} className="f2rem b--dark-gray bb bt-l br-l bg-gray no-underline hover-bg-silver bg-animate pa2 w-100 tc near-white">Event Calendar</Link>
            <Link to="/living" onClick={() => this.toggleMenu()} className="f2rem b--dark-gray bb bt-l br-l bg-gray no-underline hover-bg-silver bg-animate pa2 w-100 tc near-white">Living in Eureka</Link>
            <Link to="/history" onClick={() => this.toggleMenu()} className="f2rem b--dark-gray bb bt-l br-l bg-gray no-underline hover-bg-silver bg-animate pa2 w-100 tc near-white">History</Link>
            <a className="f2rem b--dark-gray bb bt-l br-l bg-gray no-underline hover-bg-silver bg-animate pa2 w-100 tc near-white" href="http://KBRealtyTeamSTL.com">Real Estate</a>
          </div>
        }
      </nav>
    )
  }
}

export default ReactTimeout(Header)


// WEBPACK FOOTER //
// ./src/components/multi/Header.js